'use client';
import * as React from "react";
const valueIdContext = React.createContext(undefined);
export const valueIdContextDefaultValue = '';
export const useValueIdContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(valueIdContext)) !== null && _React_useContext !== void 0 ? _React_useContext : valueIdContextDefaultValue;
};
export const ValueIdContextProvider = valueIdContext.Provider;
